import 'react';
import clsx from 'clsx';
import 'prop-types';
import { Col, Box, PositionedOverlay, PositionedOverlayBase, PositionedOverlayAnchor, Badge } from 'reaxl';
import { jsxs, jsx } from 'react/jsx-runtime';
function MyWalletGridTiles(_ref) {
  let {
    className = '',
    tileProps = {},
    alignmentEnabled,
    xs,
    sm,
    md,
    lg,
    ...rest
  } = _ref;
  const {
    badge = '',
    category = '',
    headline = '',
    summary = '',
    onClick = () => {},
    onKeyDown = () => {},
    contentMinHeight = '',
    dataCmp = ''
  } = tileProps;
  const boxProps = {
    className: clsx('flex-1 margin-vertical-2', className),
    onKeyDown,
    ...rest
  };
  if (onClick) {
    boxProps.onClick = onClick;
    boxProps.tabIndex = 0;
    boxProps.role = 'button';
  }
  const columnProps = {
    ...(xs && {
      xs
    }),
    ...(sm && {
      sm
    }),
    ...(md && {
      md
    }),
    ...(lg && {
      lg
    })
  };
  const withPositionedOverlay = children => /*#__PURE__*/jsx(PositionedOverlay, {
    shrinkwrap: false,
    children: /*#__PURE__*/jsxs(PositionedOverlayBase, {
      children: [children, /*#__PURE__*/jsx(PositionedOverlayAnchor, {
        offsetRight: 75,
        offsetTop: 75,
        position: "topRight",
        children: /*#__PURE__*/jsx(Badge, {
          circle: true,
          children: "1"
        })
      }, "tradeInOverlayAnchor")]
    }, "tradeInBadgeOverlayBase")
  });
  const renderContents = /*#__PURE__*/jsxs("div", {
    className: clsx('display-flex flex-column', alignmentEnabled ? 'justify-content-center' : 'justify-content-between'),
    style: contentMinHeight ? {
      height: contentMinHeight
    } : undefined,
    children: [category ?? category, headline && /*#__PURE__*/jsx("div", {
      children: headline
    }), summary ?? summary]
  });
  return /*#__PURE__*/jsx(Col, {
    className: "display-flex",
    "data-cmp": "wallet-grid-tile-container",
    ...columnProps,
    children: /*#__PURE__*/jsx(Box, {
      backgroundColor: "neutral-primary",
      border: true,
      "data-cmp": dataCmp,
      padding: "compact",
      ...boxProps,
      children: (category || headline || summary) && (badge ? withPositionedOverlay(renderContents) : renderContents)
    })
  });
}
export { MyWalletGridTiles as default };
